export enum ClaimStatus {
    DRAFT = 'Borrador',
    PENDING ='Pendiente',
    REFUSED ='Rechazado',
    FINALIZED ='Finalizado',
    IN_INTERNAL_PROCESS = 'EnTramiteInterno',
    AUDIENCE_SET = 'AudienciaFijada',
    ADMITTED = 'Admitido',
}
